import styled from 'styled-components';

export const StyledIcon = styled.span`
  padding-right: 10px;
`;

export const EmailSpan = styled.span`
  padding-right: 10px;
`;
